import { gql } from '@edreamsodigeo/frontend-api-client';

export const getSubscriptionOffers = gql`
  query SubscriptionOffers($request: SubscriptionOffersRequest) @ignore_update {
    subscriptionOffers(request: $request) {
      price {
        amount
        currency
      }
      offerId
      renewalPrice {
        amount
        currency
      }
      duration {
        amount
        timeUnit
      }
      renewalDuration {
        amount
        timeUnit
      }
      subscriptionPeriod
      catalogueOffer {
        membershipOfferId
        plan {
          planName
          membershipTier {
            membershipTierId
            policies {
              autoRenewalPolicy {
                deactivationConditions
              }
            }
          }
        }
      }
      type
    }
  }
`;
